import { cn } from '@/lib/cn';
import { For, type JSX, Show } from 'solid-js';

export interface TabsProps {
  tabs: readonly { id: string; label: string; count?: number }[];
  active: string;
  onChange: (id: string) => void;
  class?: string;
}

export const Tabs = (props: TabsProps): JSX.Element => (
  <div
    class={cn(
      'flex items-center gap-2 border-b border-neutral-200 dark:border-neutral-800',
      props.class,
    )}
    role="tablist"
  >
    <For each={props.tabs}>
      {(tab) => (
        <button
          type="button"
          role="tab"
          aria-selected={props.active === tab.id}
          class={cn(
            '-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors',
            props.active === tab.id
              ? 'border-brand-600 text-brand-600 dark:border-brand-400 dark:text-brand-400'
              : 'border-transparent text-neutral-500 hover:text-neutral-700 dark:text-neutral-400 dark:hover:text-neutral-200',
          )}
          onClick={() => props.onChange(tab.id)}
        >
          {tab.label}
          <Show when={tab.count !== undefined}>
            <span
              class={cn(
                'ml-1.5 rounded-full px-1.5 py-0.5 text-xs tabular-nums transition-colors',
                props.active === tab.id
                  ? 'bg-brand-50 text-brand-600 dark:bg-brand-900/30 dark:text-brand-400'
                  : 'bg-neutral-100 text-neutral-500 dark:bg-neutral-800 dark:text-neutral-400',
              )}
            >
              {tab.count}
            </span>
          </Show>
        </button>
      )}
    </For>
    <Show when={false}>{null}</Show>
  </div>
);
